import React, { useMemo } from 'react'
import { Box, Dialog, IconButton, Typography } from '@mui/material'
import {
  convertDateToString,
  checkIsBase64,
  removeMime,
} from '../../lib/helpers'
import EditIcon from '@mui/icons-material/Edit'
import ClearIcon from '@mui/icons-material/Clear'
import PhotoLabel from './styled/PhotoLabel'
import PhotoToShow from './PhotoToShow'
import { useTranslation } from 'react-i18next'

export default function PhotoPreviewWindow({
  title,
  open,
  handleClose,
  photo,
  photoToday,
  timestamp,
  setDialogState,
  dateToday,
}: {
  title: string
  open: boolean
  handleClose: () => void
  photo: string
  photoToday: string
  timestamp: string
  setDialogState: (value: any) => void
  dateToday: string
}) {
  const { t } = useTranslation()

  const previewPhoto = timestamp === t('common.today') ? photoToday : photo

  const photoToShow = useMemo(() => {
    if (!previewPhoto) return null
    return checkIsBase64(previewPhoto)
      ? `data:image/*;base64,${removeMime(previewPhoto)}`
      : previewPhoto
  }, [previewPhoto])

  return (
    <Dialog
      fullScreen
      open={open}
      sx={(theme) => ({
        root: {
          paddingTop: theme.spacing(7),
          paddingBottom: theme.spacing(6),
        },
      })}
    >
      <Box
        sx={(theme) => ({
          display: 'flex',
          justifyContent: 'space-between',
          padding: theme.spacing(1),
          backgroundColor: '#000',
          boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.08)',
          position: 'fixed',
          width: '100%',
          zIndex: '10',
          top: 0,
        })}
      >
        <Box display="flex" alignItems="center">
          <IconButton
            sx={{
              '& svg': {
                color: '#fff',
              },
            }}
            size="small"
            onClick={handleClose}
          >
            <ClearIcon />
          </IconButton>
          <Typography
            variant="h1"
            sx={(theme) => ({
              marginLeft: theme.spacing(3),
            })}
          >
            {title}
          </Typography>
        </Box>
      </Box>

      {photoToShow && <PhotoToShow photoURL={photoToShow} />}
      <Box
        sx={{
          width: '100%',
          position: 'fixed',
          bottom: 0,
          backgroundColor: '#fff',
          zIndex: '10',
          boxShadow: '2px 0px 8px rgba(0, 0, 0, 0.08)',
        }}
      >
        {timestamp === t('common.today') ? (
          <PhotoLabel withPhotoLabelToday>
            <Typography variant="body1">
              {convertDateToString(dateToday, true)}
            </Typography>
            <IconButton
              size="small"
              onClick={() => {
                setDialogState({ open: true })
              }}
            >
              <EditIcon />
            </IconButton>
          </PhotoLabel>
        ) : (
          <PhotoLabel>
            <Typography variant="body1">{timestamp}</Typography>
          </PhotoLabel>
        )}
      </Box>
    </Dialog>
  )
}
